import React from 'react'

import { useIntl } from 'react-intl'
import { AppSvg, Alert, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import s from './s.module.css'
import { lang } from './lang'
import { globalLang } from '~globalLang'
import ModalView from '~components/ModalView'

interface Props {
    onClose: () => void
    onFreeze: () => void
    isLoading: boolean
}

function Question({ onClose, onFreeze, isLoading }: Props) {
    const intl = useIntl()

    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Snowflake} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} />}
            dataPointer="freeze"
            contentClassName={s.topHack}
        >
            <div className={s.alert}>
                <Alert
                    dataPointer="freeze_alert"
                    text={<FormattedHTMLMessage {...lang.alert} values={{ supportLink }} />}
                    type="warning"
                />
            </div>
            <div className={s.button}>
                <Button dataPointer="cancel" size="l" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.cancel} />
                </Button>
                <Button dataPointer="freeze" size="l" mode="primary" onClick={onFreeze} fullWidth isLoading={isLoading}>
                    <FormattedHTMLMessage {...lang.freeze} />
                </Button>
            </div>
        </ModalView>
    )
}

export default Question
